export const degreeSymbol = '\xB0';

export enum VisitSummaryTypes {
  Inpatient = 'inpatient',
  Outpatient = 'outpatient',
  Emergency = 'emergency',
  Legacy = 'legacy'
}
